import {Table as UxTable,Card,Form} from '@deere/ux.uxframe-react'
import React from 'react'
import {getAnswerLabel, getTranslation, findAnswerIndex} from '../../utils/utils'
import TableSectionReview from './TableSectionReview'
import TablePercentageReview from './TablePercentageReview'
import { QUESTION_PROPRIETARY, QUESTION_TYPES, SCBM_CHECK_CODE_EXCLUDED } from '../../utils/surveyLiterals'
import PropiertaryInfReview from './PropiertaryInfReview'
import DateOfpReviewSection from './DateOfpReviewSection'

export default function CapacityReviewSection({sectionSurvey,answers}){

    if(!sectionSurvey)
        return <></>
        
    const questions = sectionSurvey.questions.filter(qu => qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder)  ? 1 : -1)
    const colCquestions = questions ? questions.filter(q => q.type === QUESTION_TYPES.TABLE_MON):[];
    const questionFormula = questions ? questions.find(q => q.type === QUESTION_TYPES.FORMULA) : null;
    const questionTitle = questions ? questions.find(q => q.type === QUESTION_TYPES.TABLE_SECT && q.dependentQuestions.length === 0) : null;
    const listQuestions = questions ? questions.filter(q => q.type === QUESTION_TYPES.TABLE_BS):null;
    const colNames = listQuestions[0] && listQuestions[0].dependentQuestions?listQuestions[0].dependentQuestions.map(q => getTranslation(q,'text')):[];
    const propQuestion = sectionSurvey.questions.filter(qu => qu.text === QUESTION_PROPRIETARY)[0];

    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, answers) >= 0 ? answers[findAnswerIndex(propQuestion.id, answers)].answer : '' : '';
    function createRow(q){
        let answer = getAnswerLabel(q,answers);
        if(q.idQuestionDepends && (q.idQuestionDepends) > 0){
            return answer === '-'?null:<Form.Group className='mb-4 pl-4'>
                                            <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                                            <h6>{answer}</h6>
                                        </Form.Group>
        }else{
            return <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                    <h6>{answer}</h6>
                </Form.Group>
        }
           
    }

    function createCheckRow(q){
        let styleClass = '';
        let labels = getAnswerLabel(q,answers);
        labels = labels === '-' || labels === undefined?null:labels;
        if(q.idQuestionDepends && (q.idQuestionDepends) > 0){
            styleClass = 'mb-4 pl-4';
        }
        return  labels?<Form.Group className={styleClass}>
                    <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                    {labels?labels.map(lab => <li key={lab}>{lab}</li>):''}
                </Form.Group>:<Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                    <h6>-</h6>
                </Form.Group>;
           
    }

    const createTableRow = (q, index) => {
        return (
          <tr key={index}>
            <td className="p-1">{getTranslation(q, "text")}</td>
            {q.dependentQuestions
              .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
              .map((dq) => (
                <td key={dq.id}>
                  {dq.type === QUESTION_TYPES.PERC_SALES ? getAnswerLabel(dq, answers) : <></>}
                  {dq.type === QUESTION_TYPES.OPTION ? getAnswerLabel(dq, answers) : <></>}
                </td>
              ))}
          </tr>
        );
      };

    return (<div>        
                {propComments? <PropiertaryInfReview section={sectionSurvey} answer={propComments}/>:null} 
                {!propComments?<Card>
                    <Card.Body>
                    <Card.Title className='pb-3'>
                        {getTranslation(sectionSurvey, 'description')}
                    </Card.Title>
                    {questions?questions.map((q,idx) => <div key={idx}> <Form.Row className="d-block mb-4" key={idx}>
                        {q.type === QUESTION_TYPES.RADIO && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0)?createRow(q,idx):<></>}
                        {q.type === QUESTION_TYPES.OPEN && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0)?createRow(q,idx):<></>}
                        {q.type === QUESTION_TYPES.OPTION && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0)?createRow(q,idx):<></>}
                        {q.type === QUESTION_TYPES.CHECK && ((q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) && !SCBM_CHECK_CODE_EXCLUDED.includes(q.code))?createCheckRow(q,idx):<></>}
                        {q.type === QUESTION_TYPES.TABLE_SECT && (q.dependentQuestions !== 'undefined' && q.dependentQuestions.length > 0)?<TableSectionReview question={q} answers={answers}/>:<></>}
                        </Form.Row>
                        {q.type === QUESTION_TYPES.DATE_SECT ? <DateOfpReviewSection ofpSection={sectionSurvey} dateQuestion={q} answers={answers} /> : <></>}
                        </div>):<></>}
                        {colCquestions && colCquestions.length > 0 ?<TablePercentageReview questions={colCquestions}  answers={answers}/>:<></>}
                        {listQuestions && listQuestions.length > 0 && 
                            <UxTable striped hover size="sm">
                                <caption>{getTranslation(questionTitle, "text")}</caption>
                                <caption>{getTranslation(questionFormula, 'text')}</caption>
                                <thead>
                                    <tr>
                                    <th className="p-1" scope="col" style={{width: "60%"}}></th>
                                    {colNames ? (
                                        colNames.map((qt) => (
                                        <th scope="col" className="p-1 text-center" key={qt} style={{width: "40%"}}>
                                            {qt}
                                        </th>
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                    </tr>
                                </thead>
                                <tbody>{listQuestions.map((data, index) => createTableRow(data, index))}</tbody>
                            </UxTable>
                        }
                    </Card.Body>
                </Card>:null
                }
            </div>)
}   